import { ArrowLeftOutlined } from '@ant-design/icons';
import React from 'react';
import './styles.css';

interface MobileShellProps {
    title: string;
    onBack?: () => void;
    /** Optional control on the right of the title bar (e.g. online/offline). */
    headerExtra?: React.ReactNode;
    children: React.ReactNode;
}

/** Full-width, sidebar-less layout for the poolside reporter screens. */
const MobileShell: React.FC<MobileShellProps> = ({ title, onBack, headerExtra, children }) => {
    return (
        <div className="m-shell">
            <div className="m-shell__bar">
                {onBack && (
                    <button
                        type="button"
                        className="m-shell__back"
                        aria-label="Back"
                        onClick={onBack}
                    >
                        <ArrowLeftOutlined />
                    </button>
                )}
                <span className="m-shell__title">{title}</span>
                {headerExtra ? <div className="m-shell__extra">{headerExtra}</div> : null}
            </div>
            <div className="m-shell__body">{children}</div>
        </div>
    );
};

export default MobileShell;
